import { useState } from "react";
import SectionCard from "@/components/base/SectionCard";
import { currentStore } from "@/mocks/dashboard";
import {
  BankForm,
  PersonalForm,
  SecurityForm,
} from "./components/SettingsForms";

type Tab = "personal" | "bank" | "security";

const TABS: { key: Tab; label: string; icon: string; subtitle: string }[] = [
  {
    key: "personal",
    label: "البيانات الشخصية",
    icon: "ri-user-3-line",
    subtitle: "معلومات حسابك وطريقة التواصل معك",
  },
  {
    key: "bank",
    label: "البيانات البنكية",
    icon: "ri-bank-card-line",
    subtitle: "حساب التسوية الذي تُحوّل إليه مبالغك",
  },
  {
    key: "security",
    label: "الأمان",
    icon: "ri-shield-keyhole-line",
    subtitle: "كلمة المرور وسلامة حسابك",
  },
];

export default function SettingsPage() {
  const [tab, setTab] = useState<Tab>("personal");
  const activeTab = TABS.find((item) => item.key === tab) ?? TABS[0];

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
      <div className="xl:col-span-2 space-y-4">
        <div className="yc-fade-up inline-flex flex-wrap gap-1 rounded-full bg-white border border-background-200 p-1">
          {TABS.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                tab === item.key
                  ? "bg-primary-500 text-white"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              <i className={item.icon}></i>
              {item.label}
            </button>
          ))}
        </div>

        <SectionCard
          title={activeTab.label}
          subtitle={activeTab.subtitle}
          icon={activeTab.icon}
        >
          {tab === "personal" && <PersonalForm />}
          {tab === "bank" && <BankForm />}
          {tab === "security" && <SecurityForm />}
        </SectionCard>
      </div>

      <div className="space-y-4">
        <section className="yc-fade-up yc-card-hover bg-white rounded-card border border-background-200 shadow-card p-5">
          <div className="flex items-center gap-3">
            <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xl">
              <i className="ri-user-smile-line"></i>
            </span>
            <div>
              <p className="text-base font-bold text-foreground-950">
                {currentStore.ownerName}
              </p>
              <p className="text-xs text-foreground-500">
                {currentStore.brandName}
              </p>
            </div>
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-center justify-between">
              <span className="text-foreground-500">حالة الحساب</span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-1 text-xs font-semibold text-primary-800">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                نشط
              </span>
            </li>
            <li className="flex items-center justify-between">
              <span className="text-foreground-500">نوع الحساب</span>
              <span className="font-medium text-foreground-900">
                حساب محل تجاري
              </span>
            </li>
            <li className="flex items-center justify-between">
              <span className="text-foreground-500">تاريخ الانضمام</span>
              <span className="font-medium text-foreground-900">
                مارس ٢٠٢٤
              </span>
            </li>
          </ul>
        </section>

        <section className="yc-fade-up rounded-card border border-accent-300 bg-accent-50 p-5">
          <div className="flex items-center gap-2 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-800">
              <i className="ri-customer-service-2-line"></i>
            </span>
            <h3 className="text-sm font-bold text-accent-900">
              تحتاج مساعدة؟
            </h3>
          </div>
          <p className="text-xs leading-6 text-accent-900/80">
            فريق الدعم متاح لمساعدتك في تحديث بياناتك أو حل أي مشكلة تواجهها في
            حسابك.
          </p>
          <a
            href="tel:920001234"
            className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-accent-900 hover:underline"
          >
            <i className="ri-phone-line"></i>
            920001234
          </a>
        </section>
      </div>
    </div>
  );
}